// handes creating small boxes with the same jheight in up direction always
// import React, { useRef, useState, useMemo } from 'react';
// import * as THREE from 'three';
// import { useThree } from '@react-three/fiber';

// export default function NetPlane({ size = 5, divisions = 20, controlsRef }) {
//   const { camera, raycaster, mouse } = useThree();

//   const [columns, setColumns] = useState([]);
//   const isDragging = useRef(false);
//   const dragStart = useRef({ y: 0, point: null });

//   const step = size / divisions;
//   const half = size / 2;

//   const gridLines = useMemo(() => {
//     const lines = [];
//     for (let i = 0; i <= divisions; i++) {
//       const x = -half + i * step;
//       lines.push(new THREE.Vector3(x, 0, -half));
//       lines.push(new THREE.Vector3(x, 0, half));
//     }
//     for (let i = 0; i <= divisions; i++) {
//       const z = -half + i * step;
//       lines.push(new THREE.Vector3(-half, 0, z));
//       lines.push(new THREE.Vector3(half, 0, z));
//     }
//     return lines;
//   }, [divisions]);

//   const gridGeometry = useMemo(() => {
//     return new THREE.BufferGeometry().setFromPoints(gridLines);
//   }, [gridLines]);

//   const handlePointerDown = (event) => {
//     event.stopPropagation();
  
//     const plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
//     raycaster.setFromCamera(mouse, camera);
  
//     const intersectPoint = new THREE.Vector3();
//     raycaster.ray.intersectPlane(plane, intersectPoint);
  
//     if (intersectPoint) {
//       const snappedX = Math.round(intersectPoint.x / step) * step;
//       const snappedZ = Math.round(intersectPoint.z / step) * step;
  
//       // ✅ Clamp to inside the grid bounds
//       if (
//         snappedX < -half || snappedX > half ||
//         snappedZ < -half || snappedZ > half
//       ) {
//         return; // Ignore if outside
//       }
  
//       dragStart.current = { y: event.clientY, point: { x: snappedX, z: snappedZ } };
//       isDragging.current = true;
  
//       if (controlsRef?.current) {
//         controlsRef.current.enabled = false;
//       }
//     }
//   };

//   const handlePointerMove = (event) => {
//     if (!isDragging.current) return;

//     const dy = dragStart.current.y - event.clientY;
//     const deltaHeight = dy * 0.01;

//     const existing = columns.find(
//       (c) =>
//         c.x === dragStart.current.point.x && c.z === dragStart.current.point.z
//     );

//     const updated = existing
//       ? columns.map((c) =>
//           c.x === existing.x && c.z === existing.z
//             ? { ...c, height: Math.max(0.1, c.height + deltaHeight) }
//             : c
//         )
//       : [
//           ...columns,
//           {
//             x: dragStart.current.point.x,
//             z: dragStart.current.point.z,
//             height: Math.max(0.1, deltaHeight),
//           },
//         ];

//     setColumns(updated);
//     dragStart.current.y = event.clientY;
//   };

//   const handlePointerUp = () => {
//     isDragging.current = false;
//     // ✅ Re-enable camera control
//     if (controlsRef?.current) {
//       controlsRef.current.enabled = true;
//     }
//   };

//   return (
//     <group
//       onPointerDown={handlePointerDown}
//       onPointerMove={handlePointerMove}
//       onPointerUp={handlePointerUp}
//       onPointerLeave={handlePointerUp}
//     >
//       <lineSegments geometry={gridGeometry}>
//         <lineBasicMaterial color="black" />
//       </lineSegments>

//       {columns.map((col, idx) => (
//         <mesh key={idx} position={[col.x, col.height / 2, col.z]}>
//           <boxGeometry args={[step * 0.8, col.height, step * 0.8]} />
//           <meshStandardMaterial color={`hsl(${(col.x + col.z) * 60}, 80%, 60%)`} />
//         </mesh>
//       ))}
//     </group>
//   );
//  }

// handles up/down correct direction and correct height and colors based on height of column
// import React, { useRef, useState, useMemo } from 'react';
// import * as THREE from 'three';
// import { useThree } from '@react-three/fiber';

// export default function NetPlane({ size = 5, divisions = 20, controlsRef }) {
//   const { camera, raycaster, mouse } = useThree();

//   const [columns, setColumns] = useState([]);
//   const isDragging = useRef(false);
//   const dragStart = useRef({ y: 0, point: null });
//   const planeRef = useRef();

//   const step = size / divisions;
//   const half = size / 2;

//   function getColorByHeight(height, min = 0, max = 5) {
//     const clamped = Math.max(min, Math.min(height, max));
//     const t = (clamped - min) / (max - min); // normalize height 0–1
  
//     // Hue range from pink (330°) to red (0°) through the rainbow
//     const hue = (1 - t) * 330; // 330 (pink) → 0 (red)
//     return `hsl(${hue}, 80%, 60%)`;
//   }
  

//   const gridLines = useMemo(() => {
//     const lines = [];
//     for (let i = 0; i <= divisions; i++) {
//       const x = -half + i * step;
//       lines.push(new THREE.Vector3(x, 0, -half));
//       lines.push(new THREE.Vector3(x, 0, half));
//     }
//     for (let i = 0; i <= divisions; i++) {
//       const z = -half + i * step;
//       lines.push(new THREE.Vector3(-half, 0, z));
//       lines.push(new THREE.Vector3(half, 0, z));
//     }
//     return lines;
//   }, [divisions]);

//   const gridGeometry = useMemo(() => {
//     return new THREE.BufferGeometry().setFromPoints(gridLines);
//   }, [gridLines]);

//   const handlePointerDown = (event) => {
//     event.stopPropagation();

//     const plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
//     raycaster.setFromCamera(mouse, camera);

//     const intersectPoint = new THREE.Vector3();
//     raycaster.ray.intersectPlane(plane, intersectPoint);

//     if (intersectPoint) {
//       const snappedX = Math.round(intersectPoint.x / step) * step;
//       const snappedZ = Math.round(intersectPoint.z / step) * step;

//       if (
//         snappedX < -half || snappedX > half ||
//         snappedZ < -half || snappedZ > half
//       ) return;

//       dragStart.current = {
//         y: event.clientY,
//         point: { x: snappedX, z: snappedZ }
//       };
//       isDragging.current = true;

//       if (controlsRef?.current) {
//         controlsRef.current.enabled = false;
//       }
//     }
//   };

//   const handlePointerMove = (event) => {
//     if (!isDragging.current) return;

//     const { x, z } = dragStart.current.point;
//     const initialY = dragStart.current.y;

//     const pixelDelta = initialY - event.clientY; // move up = positive
//     const height = pixelDelta * 0.01;

//     const existing = columns.find((c) => c.x === x && c.z === z);

//     const updated = existing
//       ? columns.map((c) =>
//           c.x === x && c.z === z ? { ...c, height } : c
//         )
//       : [...columns, { x, z, height }];

//     setColumns(updated);
//   };

//   const handlePointerUp = () => {
//     isDragging.current = false;
//     if (controlsRef?.current) {
//       controlsRef.current.enabled = true;
//     }
//   };

//   return (
//     <group>
//       {/* ✅ Invisible background interaction plane */}
//       <mesh
//          ref={planeRef}
//          position={[0, 0, 0]}
//          rotation={[-Math.PI / 2, 0, 0]}
//          onPointerDown={handlePointerDown}
//          onPointerMove={handlePointerMove}
//          onPointerUp={handlePointerUp}
//          onPointerLeave={handlePointerUp}
//       >
//         <planeGeometry args={[size * 10, size * 10]} />
//         <meshBasicMaterial transparent opacity={0} side={THREE.DoubleSide}/>
//       </mesh>

//       {/* ✅ Grid lines */}
//       <lineSegments geometry={gridGeometry}>
//         <lineBasicMaterial color="black" />
//       </lineSegments>

//       {/* ✅ Columns */}
//       {columns.map((col, idx) => {
//         const boxHeight = Math.abs(col.height);
//         const yOffset = col.height >= 0 ? boxHeight / 2 : -boxHeight / 2;

//         return (
//           <mesh
//             key={idx}
//             position={[col.x, yOffset, col.z]}
//           >
//             <boxGeometry args={[step * 0.8, boxHeight, step * 0.8]} />
//             <meshStandardMaterial color={getColorByHeight(col.height)} />
//           </mesh>
//         );
//       })}
//     </group>
//   );
// }

import React, { useRef, useState, useMemo } from 'react';
import * as THREE from 'three';
import { useThree } from '@react-three/fiber';

export default function NetPlane({size = 5, divisions = 20, controlsRef,theme}) {
  const { camera, raycaster, mouse } = useThree();

  const [columns, setColumns] = useState([]);
  const isDragging = useRef(false);
  const dragStart = useRef({ y: 0, point: null });
  const planeRef = useRef();

  const step = size / divisions;
  const half = size / 2;
  const maxHeight = 5; // Max height for gradient normalization

  function getColorFromGradient(t) {
    const hue = (1 - t) * 330; // 0 = red, 1 = pink
    const color = new THREE.Color();
    color.setHSL(hue / 360, 0.8, 0.6);
    return color;
  }

  const hillMaterial = useMemo(() => {
    return new THREE.ShaderMaterial({
      vertexShader: `
        varying vec3 vPosition;

        void main() {
          vPosition = (modelMatrix * vec4(position, 1.0)).xyz;
          gl_Position = projectionMatrix * viewMatrix * vec4(vPosition, 1.0);
        }
      `,
      fragmentShader: `
      uniform float stepHeight;
      varying vec3 vPosition;

      vec3 getColor(float y) {
        float band = floor(y / stepHeight);
        float t = mod(y, stepHeight) / stepHeight;

        if (band == 0.0) return mix(vec3(1.0, 0.8, 0.9), vec3(0.8, 0.6, 1.0), t); // pink to purple
        if (band == 1.0) return mix(vec3(0.8, 0.6, 1.0), vec3(0.6, 0.6, 1.0), t); // purple to blue
        if (band == 2.0) return mix(vec3(0.6, 0.6, 1.0), vec3(0.6, 1.0, 0.6), t); // blue to green
        if (band == 3.0) return mix(vec3(0.6, 1.0, 0.6), vec3(1.0, 1.0, 0.4), t); // green to yellow
        if (band == 4.0) return mix(vec3(1.0, 1.0, 0.4), vec3(1.0, 0.6, 0.0), t); // yellow to orange
        if (band == 5.0) return mix(vec3(1.0, 0.6, 0.0), vec3(0.9, 0.3, 0.3), t); // orange to red

        return vec3(0.9, 0.3, 0.3); // clamp to red beyond range
      }

      void main() {
        float y = abs(vPosition.y);
        vec3 color = getColor(y);
        gl_FragColor = vec4(color, 1.0);
      }
      `,
      uniforms: {
        stepHeight: { value: 0.5 }
      },      
      side: THREE.DoubleSide,
      transparent: false,
      depthWrite: true,
    });
  }, [step]);

  function createGaussianHillGeometry(radius, height, direction = 1, radialSegments = 32, radialSteps = 16) {
    const positions = [];
    const indices = [];
  
    const sigma = radius / 2.5;
  
    for (let i = 0; i <= radialSteps; i++) {
      const r = (i / radialSteps) * radius;
      for (let j = 0; j <= radialSegments; j++) {
        const theta = (j / radialSegments) * Math.PI * 2;
        const x = r * Math.cos(theta);
        const z = r * Math.sin(theta);
        const rNorm = r / radius;
        const y = direction * height * Math.pow(1 - rNorm * rNorm, 2); // Flips the hill down if direction = -1
        positions.push(x, y, z);
      }
    }
  
    for (let i = 0; i < radialSteps; i++) {
      for (let j = 0; j < radialSegments; j++) {
        const a = i * (radialSegments + 1) + j;
        const b = a + radialSegments + 1;
  
        indices.push(a, b, a + 1);
        indices.push(b, b + 1, a + 1);
      }
    }
  
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
    geometry.setIndex(indices);
    geometry.computeVertexNormals();
    if (direction === -1) {
      const normalAttr = geometry.attributes.normal;
      for (let i = 0; i < normalAttr.count; i++) {
        normalAttr.setXYZ(
          i,
          -normalAttr.getX(i),
          -normalAttr.getY(i),
          -normalAttr.getZ(i)
        );
      }
      normalAttr.needsUpdate = true;
    }
  
    return geometry;
  }
  
  
  const gridLines = useMemo(() => {
    const lines = [];
    for (let i = 0; i <= divisions; i++) {
      const x = -half + i * step;
      lines.push(new THREE.Vector3(x, 0, -half));
      lines.push(new THREE.Vector3(x, 0, half));
    }
    for (let i = 0; i <= divisions; i++) {
      const z = -half + i * step;
      lines.push(new THREE.Vector3(-half, 0, z));
      lines.push(new THREE.Vector3(half, 0, z));
    }
    return lines;
  }, [divisions]);

  const gridGeometry = useMemo(() => {
    return new THREE.BufferGeometry().setFromPoints(gridLines);
  }, [gridLines]);

  const handlePointerDown = (event) => {
    event.stopPropagation();

    const plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
    raycaster.setFromCamera(mouse, camera);

    const intersectPoint = new THREE.Vector3();
    raycaster.ray.intersectPlane(plane, intersectPoint);

    if (intersectPoint) {
      const snappedX = Math.round(intersectPoint.x / step) * step;
      const snappedZ = Math.round(intersectPoint.z / step) * step;

      if (
        snappedX < -half || snappedX > half ||
        snappedZ < -half || snappedZ > half
      ) return;

      dragStart.current = {
        y: event.clientY,
        point: { x: snappedX, z: snappedZ }
      };
      isDragging.current = true;

      if (controlsRef?.current) {
        controlsRef.current.enabled = false;
      }
    }
  };

  const handlePointerMove = (event) => {
    if (!isDragging.current) return;

    const { x, z } = dragStart.current.point;
    const initialY = dragStart.current.y;

    const pixelDelta = initialY - event.clientY;
    const height = pixelDelta * 0.01;

    const existing = columns.find((c) => c.x === x && c.z === z);

    const updated = existing
      ? columns.map((c) =>
          c.x === x && c.z === z ? { ...c, height } : c
        )
      : [...columns, { x, z, height }];

    setColumns(updated);
  };

  const handlePointerUp = () => {
    isDragging.current = false;
    if (controlsRef?.current) {
      controlsRef.current.enabled = true;
    }
  };

  return (
    <group>
      {/* ✅ Invisible background interaction plane */}
      <mesh
         ref={planeRef}
         position={[0, 0, 0]}
         rotation={[-Math.PI / 2, 0, 0]}
         onPointerDown={handlePointerDown}
         onPointerMove={handlePointerMove}
         onPointerUp={handlePointerUp}
         onPointerLeave={handlePointerUp}
      >
        <planeGeometry args={[size * 10, size * 10]} />
        <meshBasicMaterial transparent opacity={0} side={THREE.DoubleSide}/>
      </mesh>

      {/* ✅ Grid lines */}
      <lineSegments geometry={gridGeometry}>
        <lineBasicMaterial color={theme == "light" ? "black" : "white"} />
      </lineSegments>

      {/* ✅ Columns */}
      {columns.map((col, idx) => {
        const radius = step / 2;
        const direction = col.height >= 0 ? 1 : -1;
        const geometry = createGaussianHillGeometry(radius, Math.abs(col.height), direction);

        return (
          <mesh
            key={idx}
            position={[col.x, 0, col.z]}
            geometry={geometry}
            frustumCulled={false} // ✅ Keeps near-camera hills visible
          >
          {/* <meshStandardMaterial color={direction === 1 ? "orange" : "blue"} side={THREE.DoubleSide} /> */}
          <primitive object={hillMaterial.clone()} attach="material" />
          </mesh>
        );
      })}


    </group>
  );
}